import { render, staticRenderFns } from "./rateHistoryDetail.vue?vue&type=template&id=6d580ba2&scoped=true"
import script from "./rateHistoryDetail.vue?vue&type=script&lang=js"
export * from "./rateHistoryDetail.vue?vue&type=script&lang=js"
import style0 from "./rateHistoryDetail.vue?vue&type=style&index=0&id=6d580ba2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d580ba2",
  null
  
)

export default component.exports